import React from 'react'
import { useTranslation } from 'react-i18next'

import { getTranslate } from 'helpers/translate'
import ServerFileLink from 'components/ServerFileLink'
import './ProductsStep.scss'

interface Props {
  benefits: Benefit[]
  onSubmit(benefit: Benefit): void
  onPrev(): void
}

const ProductsStep = ({ benefits, onPrev, onSubmit }: Props) => {
  const { t, i18n } = useTranslation()


    const orderPortfolios = (items: Benefit[]) => {
        const portfolioOrder = new Map([
            ['Prudent Portfolio', 0],
            ['Moderate Portfolio', 1],
            ['Decisive Portfolio', 2],
            ['Very Decisive Portfolio', 3]
        ])

        return [...items].sort((a, b) =>
            (portfolioOrder.get(a.name) ?? 999) - (portfolioOrder.get(b.name) ?? 999)
        )
    }


    const orderedBenefits = orderPortfolios(benefits)

  return (
    <div>
      <div className="row product-selection no-gutters">
        {orderedBenefits.map(benefit => {
          let longDesc: string
          if (i18n.language === 'es') {
            longDesc = benefit.spanishLongDesc
          } else if (i18n.language === 'ca') {
            longDesc = benefit.catalanLongDesc
          } else if (i18n.language === 'pt') {
            longDesc = benefit.portugueseLongDesc
          } else {
            longDesc = benefit.longDesc
          }
          return (
            !benefit.parentId && (
              <div
                key={benefit.id}
                className="col-12 col-sm-6"
                onClick={() => {
                  onSubmit(benefit)
                }}
              >
                <div className="product">
                  <h4>{getTranslate(benefit, 'name', i18n.language)}</h4>
                  <div className="category">{benefit.savingsType}</div>
                  <div
                    className="long-desc"
                    dangerouslySetInnerHTML={{
                      __html: longDesc,
                    }}
                  />
                  {benefit.label1File && (
                    <ServerFileLink
                      src={benefit.label1File}
                      className="btn btn-info btn-sm btn-document-link"
                    >
                      <i className="entypo-info" />
                    </ServerFileLink>
                  )}
                </div>
                <div className="text-center mt-3">
                  <button type="button" className="btn-none">
                    <i className="fa fa-search"></i>{' '}
                    {t('buttons.select')}
                  </button>
                </div>
              </div>
            )
          )
        })}
      </div>
      <div className="text-center mt-3">
        <button type="button" className="btn-none" onClick={onPrev}>
          <i className='fa fa-arrow-left'></i>{' '}
          {t('buttons.back')}
        </button>
      </div>
    </div>
  )
}

export default ProductsStep